import * as TK from 'components/profile/ManageGivingLinkDialog/translations/constants';
import { Translations } from 'translations/types';

export const manageGivingLinkDialogEnUsLocale: Translations = {
  [TK.MANAGE_GIVING_LINK_DIALOG_TITLE]: 'Giving Link',
  [TK.MANAGE_GIVING_LINK_DIALOG_ICON_ALT]: 'Attachment icon',
};
